import type { Plugin } from './plugin'
import type { State } from './state'

/**
 * Selectors for duplicate detection state
 */
export class Selectors {
  /**
   * List of employees matching the current name and job title.
   *
   * NOTE: Intentionally not typed here so that type can be inferred
   *
   * @see {@link State.duplicates}
   */
  public readonly duplicates
  /**
   * Whether there are duplicates to display. Returns false while checking to
   * avoid showing stale results.
   *
   * NOTE: Intentionally not typed here so that type can be inferred
   */
  public readonly hasDuplicates
  /**
   * Whether a duplicate check is currently in progress.
   *
   * NOTE: Intentionally not typed here so that type can be inferred
   *
   * @see {@link State.isChecking}
   */
  public readonly isChecking

  constructor(plugin: Plugin) {
    this.duplicates = plugin.feature.state.project(state => state.duplicates)
    this.hasDuplicates = plugin.feature.state.project(
      state => state.duplicates.length > 0 && !state.isChecking,
    )
    this.isChecking = plugin.feature.state.project(state => state.isChecking)
  }
}
